import React from 'react';
import { Link } from 'react-router-dom';
import { Alert } from 'reactstrap';
import i18next from 'i18next';

import { AnyRestaruant } from 'types';

interface IProps {
  restaurant: AnyRestaruant;
  type: 'reservations' | 'orders';
}

const RestaurantIsNotLiveAlert: React.FC<IProps> = ({ restaurant, type }) => {
  if (restaurant.status === 'live') {
    return null;
  }
  return (
    <Alert color="primary">
      <p>{i18next.t('restaurant-not-live-alert.test-mode')}</p>
      {type === 'reservations' && (
        <div>
          <p>
            {i18next.t('restaurant-not-live-alert.reservations-description')}
          </p>
          <p>
            <Link to="/settings/reservations">{i18next.t('restaurant-not-live-alert.reservations-configure-link')}</Link>
          </p>
          <p>
            {i18next.t('restaurant-not-live-alert.reservations-activate-hint')}
            <div>
              <Link to="/help">{i18next.t('restaurant-not-live-alert.reservations-contact')}</Link>
            </div>
          </p>
        </div>
      )}
      {type === 'orders' && (
        <div>
          <p>
            {i18next.t('restaurant-not-live-alert.orders-description')}
          </p>
          <p>
            <Link to="/settings/orders">{i18next.t('restaurant-not-live-alert.orders-configure-link')}</Link>
          </p>
          <p>
            {i18next.t('restaurant-not-live-alert.orders-activate-hint')}
            <div>
              <Link to="/help">{i18next.t('restaurant-not-live-alert.orders-contact')}</Link>
            </div>
          </p>
        </div>
      )}
    </Alert>
  );
};

export default RestaurantIsNotLiveAlert;
